import { render, staticRenderFns } from "./EmbeddedFile.vue?vue&type=template&id=0113932e&scoped=true&"
import script from "./EmbeddedFile.vue?vue&type=script&lang=ts&"
export * from "./EmbeddedFile.vue?vue&type=script&lang=ts&"
import style0 from "./EmbeddedFile.vue?vue&type=style&index=0&id=0113932e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0113932e",
  null
  
)

export default component.exports